import React from 'react';
import { AvatarImage } from '@app/components/atm.avatar/avatar.component';
import { UserLinkStyled } from './user-button.component.style';
export const UserButton = (props) => {
    return (React.createElement(UserLinkStyled, { onClick: props.onClick, variant: 'link' },
        React.createElement(AvatarImage, { src: props.avatarUrl, size: 'xLarge' }),
        " ",
        props.userName));
};
